import React from "react";
import "./style.css";
import "animate.css";

function About(props) {
  return (
    <div className="bg-gray-100 py-8 px-4 lg:px-0 md:mb-6 animate__animated animate__fadeIn">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Онлайн дүкөнүбүзгө кош келиңиздер!{" "}
          <span className="text-3xl font-semibold">"AJAR MEBEL"</span> – 10 жылдык
          тажрыйбага ээ, өзүнүн өндүрүшүнөн түздөн-түз жогорку сапаттагы мебелди
          сатып алууга мүмкүнчүлүк түзөт. <span className="text-xl font-medium">
            <br /> Биз бардык мебелге 1 жылдан кем эмес
          сапат кепилдигин сунуштайбыз.
            </span>
        </h2>
        <strong>Биздин артыкчылыктар:</strong>
        <ul className="list-disc text-lg pl-6 text-gray-700 mb-6">
          <li>
            Түз жеткирүү: Биз сиздерге түз эле цехтен чыгарылган кеңири
            ассортименттеги стол менен стулдарды сунуштайбыз. Бул сапаттын
            жогору болушун жана өзгөчө дизайнын камсыздайт.
          </li>

          <li>
            Кепилденген сапат: Эң жакшы материалдар жана тажрыйбалуу өндүрүш
            менен ар бир буюмдун бышык жана ишенимдүү болушун кепилдешебиз.
          </li>
          <li>
            Оптовый баа: Бизден сатып алуу менен сиздер бардык мебелге керемет
            оптовый баалардан пайдалана аласыздар.
          </li>
          <li>
            Кыргызстан боюнча жеткирүү: Биз бардык Кыргызстан боюнча ыкчам жана
            ишенимдүү жеткирүүнү камсыздайбыз, бул сиздер үчүн ыңгайлуулукту
            жана коопсуздукту кепилдейт.
          </li>
        </ul>
      </div>
    </div>
  );
}

export default About;
